import React from 'react';
import styles from './GenericForm.module.css';
import Select from 'react-select';
import ReactMarkdown from 'react-markdown';

interface GenericFormProps {
  inputs: Array<{
    name: string;
    label: string;
    type: string;
    value: string | number | boolean;
    error?: string;
    options?: Array<{ value: string | number; label: string }>; // For select inputs
  }>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  submitLabel: string;
}

const GenericForm: React.FC<GenericFormProps> = ({ inputs, onChange, onSubmit, submitLabel = 'Submit' }) => {
  return (
    <form onSubmit={onSubmit} className={styles.formContainer}>
      {inputs.map((input) => (
        <div
          key={input.name}
          className={`${styles.formGroup} ${input.type === 'checkbox' ? styles.checkboxGroup : ''}`}
        >
          {input.type === 'checkbox' ? (
            <>
              <input
                type="checkbox"
                name={input.name}
                checked={input.value as boolean}
                onChange={onChange}
                className={styles.checkboxInput}
              />
              <label className={styles.checkboxLabel}>{input.label}</label>
            </>
          ) : input.type === 'select' ? (
            <>
              <label className={styles.formLabel}>{input.label}</label>
              <Select
                options={input.options}
                value={input.options?.find((opt) => opt.value === input.value)}
                onChange={(selectedOption) =>
                  onChange({
                    target: {
                      name: input.name,
                      value: selectedOption ? selectedOption.value : '',
                    },
                  } as React.ChangeEvent<HTMLInputElement>)
                }
                placeholder="Type to search..."
                className={styles.selectInput}
              />
            </>
          ) : input.type === 'radio' ? (
            <>
              <label className={styles.formLabel}>{input.label}</label>
              <div className={styles.radioGroup}>
                {input.options?.map((option) => (
                  <label key={option.value} className={styles.radioLabel}>
                    <input
                      type="radio"
                      name={input.name}
                      value={option.value}
                      checked={input.value === option.value}
                      onChange={onChange}
                      className={styles.radioInput}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </>
          ) : (
            <>
              <label className={styles.formLabel}>{input.label}</label>
              <input
                type={input.type}
                name={input.name}
                value={input.value as string | number}
                onChange={onChange}
                className={styles.formInput}
              />
            </>
          )}
          {input.error && <ReactMarkdown className={styles.errorText}>{input.error}</ReactMarkdown>}
        </div>
      ))}
      <button type="submit" className={styles.formButton}>{submitLabel}</button>
    </form>
  );
};

export default GenericForm;